module.exports = __webpack_public_path__ + "img/佛山天珺秀台.818d2efe.png";